import { Product, CartItem } from '../models';

export type ProfileAllocation = 'required' | 'optional' | 'none';

export const DEFAULT_ALLOCATION_HINT = 'Optional — leave unassigned for a guest or shared item';

/**
 * Resolve a product's allocation mode. Prefers the API-emitted value (smart API,
 * dumb app); falls back to the legacy type-based behavior so stale app builds
 * keep working if the field is ever absent.
 */
export const resolveProfileAllocation = (product: Product): ProfileAllocation => {
    if (product.profileAllocation) {
        return product.profileAllocation;
    }
    if (product.type === 'package') return 'required';
    if (product.type === 'item') return 'none';
    return 'optional'; // event_package
};

export const requiresProfile = (allocation: ProfileAllocation): boolean => allocation === 'required';

export const allowsGuest = (allocation: ProfileAllocation): boolean => allocation === 'optional';

export const resolveCtaLabel = (product: Product): string => {
    if (product.ctaLabel) return product.ctaLabel;
    if (product.type === 'event_package') return 'Get Ticket';
    if (product.type === 'item') return 'Add Item';
    return 'Add Package';
};

export const resolveAllocationHint = (product: Product, allocation: ProfileAllocation): string | null => {
    if (allocation !== 'optional') return null;
    return product.allocationHint ?? DEFAULT_ALLOCATION_HINT;
};

/** First cart item that requires a profile but has none assigned, if any. */
export const findUnassignedRequiredItem = (cart: CartItem[]): CartItem | undefined =>
    cart.find(item => requiresProfile(resolveProfileAllocation(item.product)) && item.learnerId == null);
